import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./Faq.css";

const Faq = () => {
  const { t } = useTranslation("faq");

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const sections = t("sections", { returnObjects: true });

  return (
    <main className="faq-page">
      <section className="faq-hero">
        <div className="faq-hero__inner">
          <h1>
            {t("hero.titleHighlight", { defaultValue: "Preguntas" })}{" "}
            <span>{t("hero.titleRest", { defaultValue: "frecuentes" })}</span>
          </h1>

          <p>
            {t("hero.description", {
              defaultValue:
                "Resolvemos las dudas más comunes sobre ZY, becas, beneficios y herramientas financieras.",
            })}
          </p>
        </div>
      </section>

      <section className="faq-content">
        {Array.isArray(sections) &&
          sections.map((sec, index) => (
            <article key={sec.id || sec.title} className="faq-section">
              <div className="faq-section__header">
                <span className="faq-section__number">
                  {String(index + 1).padStart(2, "0")}
                </span>

                <h2>{sec.title}</h2>
              </div>

              <div className="faq-details">
                {sec.items.map((item, i) => (
                  <details
                    key={`${sec.id || sec.title}-${i}`}
                    className="faq-detail"
                  >
                    <summary>
                      <span>{item.q}</span>
                    </summary>

                    <div className="faq-detail__answer">
                      <p>{item.a}</p>
                    </div>
                  </details>
                ))}
              </div>
            </article>
          ))}
      </section>
    </main>
  );
};

export default Faq;
